module.exports = __webpack_public_path__ + "html/wave-landing-ads_675217ebbc5df1a20ddc0012f74ca25d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave/wave-landing-ads.html
// module id = gS/5
// module chunks = 24